module.exports = __webpack_public_path__ + "img/create-account-office.41b2c6a1.jpeg";